import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import CancellationAndRefundPolicy from './Components/CancellationAndRefundPolicy';
import Navigation from './Components/Navigation';
import PiracyAndMisuseClause from './Components/PiracyAndMisuseClause';
import PrivacyPolicy from './Components/PrivacyPolicy';
import ShippingPolicy from './Components/ShippingPolicy';
import TermsAndConditions from './Components/TermsAndConditions';

function App() {
  return (
    <Router>
      <div>
        <Navigation />
        <Routes>
          <Route path="/" element={<Navigate to="/smileguide/PrivacyPolicy" replace />} />
          <Route path="/smileguide/TermsAndConditions" element={<TermsAndConditions />} />
          <Route
            path="/smileguide/Cancellation&RefundPolicy"
            element={<CancellationAndRefundPolicy />}
          />
          <Route path="/smileguide/Piracy&MisuseClause" element={<PiracyAndMisuseClause />} />
          <Route path="/smileguide/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/smileguide/ShippingPolicy" element={<ShippingPolicy />} />
          <Route path="*" element={<h2>Page Not Found</h2>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
